import { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, setDoc } from "firebase/firestore";
import {
  Frame,
  Header,
  Loading,
  Print,
  ValidaUid,
  VerContrato,
} from "../components";
import { db } from "../config/firebase";

const Aceite = () => {
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [modalErro, setModalErro] = useState({
    show: false,
    titulo: "",
    mensagem: "",
    redirecionar: false,
  });

  const navigate = useNavigate();

  const abrirModalErro = ({
    titulo = "Erro",
    mensagem,
    redirecionar = false,
  }) => {
    setModalErro({ show: true, titulo, mensagem, redirecionar });
  };

  const fecharModalErro = () => {
    const deveRedirecionar = modalErro.redirecionar;
    setModalErro((estadoAtual) => ({ ...estadoAtual, show: false }));
    if (deveRedirecionar) {
      navigate("../home");
    }
  };

  const salvarAceite = async () => {
    if (!dados?.uid) {
      abrirModalErro({
        titulo: "Usuário não identificado",
        mensagem:
          "Não foi possível identificar o usuário responsável pelo aceite.",
        redirecionar: true,
      });
      return false;
    }

    const statusAtual = dados.status === "a" ? "a" : "p";

    await setDoc(
      doc(db, "ebserh2026", dados.uid),
      { status: statusAtual, anoAtual: "2026" },
      { merge: true },
    );
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (salvando) {
      return;
    }
    try {
      setSalvando(true);
      const salvo = await salvarAceite();
      if (salvo) {
        navigate("../home");
      }
    } catch (error) {
      console.error("Erro ao registrar o aceite do contrato:", error);
      abrirModalErro({
        titulo: "Erro ao confirmar contrato",
        mensagem:
          "Não foi possível registrar o aceite do contrato. Verifique sua conexão e tente novamente.",
      });
    } finally {
      setSalvando(false);
    }
  };

  useEffect(() => {
    let componenteAtivo = true;

    const buscarDados = async () => {
      try {
        const uid = await ValidaUid();

        if (!uid) {
          navigate("/login", { replace: true });
          return;
        }

        const snapshot = await getDoc(doc(db, "ebserh2026", uid));

        if (!snapshot.exists()) {
          abrirModalErro({
            titulo: "Cadastro não encontrado",
            mensagem:
              "Não foi possível encontrar os dados necessários para exibir o contrato.",
            redirecionar: true,
          });
          return;
        }

        const data = snapshot.data();
        if (data?.anoAtual === "2026" && data?.status) {
          navigate("../home");
          return;
        }

        if (componenteAtivo) {
          setDados({ ...data, uid });
        }
      } catch (error) {
        console.error("Erro ao buscar dados do contrato:", error);

        if (componenteAtivo) {
          abrirModalErro({
            titulo: "Erro ao carregar contrato",
            mensagem:
              "Não foi possível carregar os dados do contrato. Tente novamente.",
            redirecionar: true,
          });
        }
      } finally {
        if (componenteAtivo) {
          setLoading(false);
        }
      }
    };

    buscarDados();

    return () => {
      componenteAtivo = false;
    };
  }, [navigate]);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Header nome={dados?.nome} foto={dados?.urlFoto} />

      <Frame
        body={
          <form autoComplete="off" onSubmit={handleSubmit} noValidate>
            <VerContrato dados={dados} />
            <div className="d-flex justify-content-end mt-3">
              <Print />
            </div>
            <Row className="mt-4">
              <Col xs={12} className="d-grid">
                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  className="fw-semibold py-2"
                  disabled={salvando}
                >
                  {salvando ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        className="me-2"
                        aria-hidden="true"
                      />
                      Confirmando...
                    </>
                  ) : (
                    "Li e concordo com os termos do serviço"
                  )}
                </Button>
              </Col>
            </Row>
          </form>
        }
      />

      <Modal
        show={modalErro.show}
        onHide={fecharModalErro}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalErro.titulo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">{modalErro.mensagem}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={fecharModalErro}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default Aceite;
